module.exports = __webpack_public_path__ + "img/pro_fourteen_10.d043bb39.jpg";